<template>
  <div class="ec" v-if="list.length">
    <div class="elt-title">
      <div class="title_dian">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="txt">Brands</div>
    </div>
    <div class="ec-content">
      <Swipe class="my-swipe" :autoplay="5000" :show-indicators="false" indicator-color="'#ddd'">
        <template v-for="(item, i) in list.slice(0, 8)">
          <SwipeItem :key="i">
            <div class="brand-list grid1-3" v-if="pageSize == 3">
              <div class="brand-list-one" v-for="(c, index) in item" :key="'c-' + index" @click="linkToInvite2(c.exhibitorId)">
                <div class="one-img">
                  <img :src="c.logo" v-if="c.logo" v-load="'oLogoBig'" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
                <div class="one-compname">{{ c.shortNameEn || c.nameEn }}</div>
              </div>
              <div class="brand-list-one" v-for="(c, index) in [1, 1, 1].splice(0, pageSize - item.length)" :key="'z' + index" v-if="item.length < pageSize"></div>
            </div>
            <div class="brand-list grid1-4" v-if="pageSize == 4">
              <div class="brand-list-one" v-for="(c, index) in item" :key="'c-' + index" @click="linkToInvite2(c.exhibitorId)">
                <div class="one-img">
                  <img :src="c.logo" v-if="c.logo" v-load="'oLogoBig'" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
                <div class="one-compname">{{ c.shortNameEn || c.nameEn || c.shortName || c.name }}</div>
              </div>
              <div class="brand-list-one" v-for="(c, index) in [1, 1, 1, 1].splice(0, pageSize - item.length)" :key="'z' + index" v-if="item.length < pageSize"></div>
            </div>
            <div class="brand-list grid2-3" v-if="pageSize == 6">
              <div class="brand-list-one" v-for="(c, index) in item" :key="'c-' + index" @click="linkToInvite2(c.exhibitorId)">
                <div class="one-img">
                  <img :src="c.logo" v-if="c.logo" v-load="'oLogoBig'" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
                <div class="one-compname">{{ c.shortNameEn || c.nameEn || c.shortName || c.name }}</div>
              </div>
              <div class="brand-list-one" v-for="(c, index) in [1, 1, 1, 1, 1, 1].splice(0, pageSize - item.length)" :key="'z' + index" v-if="item.length < pageSize"></div>
            </div>
            <div class="brand-list grid2-4" v-if="pageSize == 8">
              <div class="brand-list-one" v-for="(c, index) in item" :key="'c-' + index" @click="linkToInvite2(c.exhibitorId)">
                <div class="one-img">
                  <img :src="c.logo" v-if="c.logo" v-load="'oLogoBig'" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
                <div class="one-compname">{{ c.shortNameEn || c.nameEn || c.shortName || c.name }}</div>
              </div>
              <div class="brand-list-one" v-for="(c, index) in [1, 1, 1, 1, 1, 1, 1, 1].splice(0, pageSize - item.length)" :key="'z' + index" v-if="item.length < pageSize"></div>
            </div>
          </SwipeItem>
        </template>
      </Swipe> 
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
import { mapGetters, mapActions } from "vuex"; 
export default {
  name: "ex-company",
  data() {
    return {
      pageSize: 3,
      list: [],
      exList: [],
    };
  },
  props: {
    rule: {
      type: Object,
      default: {
        line: "1/3", // 1/3 1行三列； 1/4 1行四列； 2/3 2行3列；2/4 2行4列
        lineRule: [
          { value: "1/3", label: "1行3列" },
          { value: "1/4", label: "1行4列" },
          { value: "2/3", label: "2行3列" },
          { value: "2/4", label: "2行4列" },
        ],
      },
    },
  },
  components: {
    Swipe,
    SwipeItem,
  },
  created() {
    this.getExList();
    this.setRow(); 
  },
  computed: {
    ...mapGetters({
      exonId: "getExhibitionId",
      exhibitionConfig: "getExhibitionConfig",
    }),
    exhibitionId() {
      return this.$route.query.exhibitionId || this.exonId;
    },
    homeExhibitorLogo() {
      return this.exhibitionConfig ? this.exhibitionConfig.display.homeExhibitorLogo : { row: 1, col: 3 };
    },
  },
  methods: {
    ...mapActions({
      LinkExInvitation: "linkTo/LinkExInvitation",
      graphqlPostByZXS: "en/graphqlPostByZXS",
    }),
    setRow() {
      switch (this.rule.line) {
        case "1/3":
          this.pageSize = 3;
          break;
        case "1/4":
          this.pageSize = 4;
          break;
        case "2/3":
          this.pageSize = 6;
          break;
        case "2/4":
          this.pageSize = 8;
          break;
        default:
          this.pageSize = 3;
          break;
      }
    },
    getAddLength(itemL, listL) { 
      let L = ((listL > 1 || itemL > 4 ? 8 : 4) - itemL) % (listL > 1 || itemL > 4 ? 8 : 4);
      console.log(L);
      return L;
    },
    async getExList() {
      let query = `
          query($input: GetExhibitorTopByLogoInput!){
            exhibitorQuery{
              topByLogo(input:$input){
                exhibitorId
                logo
                name
                nameEn
                shortName
                shortNameEn
              }
            }
          }`;
      let body = {
        query: query,
        variables: {
          input: {
            exhibitionId: this.exhibitionId,
            num: 24,
          },
        },
      };
      let res = await this.graphqlPostByZXS(body);
      if (res.data.exhibitorQuery.topByLogo) {
        let data = JSON.parse(JSON.stringify(res.data.exhibitorQuery.topByLogo));
        if (data) {
          let ExArr = [];
          data.forEach((e, i) => {
            const c = Math.floor(i / this.pageSize);
            if (!ExArr[c]) {
              ExArr[c] = [];
            }
            ExArr[c].push(e);
          });
          this.list = ExArr;
          console.log(this.list, "this.list");
          this.$emit("requestOk", "compListIsOk");
        }
      }
    },
    linkToInvite2(exOrId) {
      this.LinkExInvitation({ exhibitorId: exOrId, exhibitionId: this.exhibitionId });
    },
  },
};
</script>

<style lang="scss" scoped>
.ec {
  padding: 0 0.3rem;
  margin-bottom: 15px;
  .elt-title {
    padding: 0.25rem 0 0;
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    color: #333;
    .title_dian {
      display: flex;
      justify-content: space-between;
      width: 0.06rem;
      height: 0.24rem;
      flex-direction: column;
      margin-right: 0.1rem;
      span {
        width: 0.06rem;
        height: 0.06rem;
        display: block;
        border-radius: 0.02rem;
        background-image: linear-gradient(90deg, #ff4b1b 0%, #fe781d 100%), linear-gradient(#108ee9, #108ee9);
        &:nth-child(1) {
          opacity: 0.5;
        }
        &:nth-child(2) {
          opacity: 0.75;
        }
      }
    }
    img {
      width: 13px;
    }
    .txt {
      font-size: 0.3rem;
      font-weight: bold;
    }
  }
  &-content {
    padding: 0;
    background: #fff;
    .brand-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 2px 5px;
      &-one {
        background-color: #fff;
        margin-bottom: 0.1rem;
        .one-img {
          border-radius: 0.1rem;
          img {
            width: 100%;
            height: 100%;
            display: block;
            box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
            padding: 0.1rem;
          }
        }
        .one-compname {
          margin-top: 0.14rem;
          color: #333;
          font-size: 0.24rem;
          text-align: center;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
}

.my-swipe {
  padding-top: 0.25rem;
  ::v-deep {
    .van-swipe__indicators {
      bottom: 1px;
    }
    .van-swipe__indicator {
      background-color: #ddd;
    }
    .van-swipe__indicator--active {
      background-color: #fe781d;
    }
    .van-swipe__track {
      padding-bottom: 10px;
    }
  }
}
.grid1-3,
.grid2-3 {
  .brand-list-one {
    width: 32%;
    .one-img {
      position: relative;
      width: 100%;
    }
  }
}
.grid1-4,
.grid2-4 {
  .brand-list-one {
    width: 22%;
    .one-img {
      position: relative;
      width: 100%;
    }
  }
}
</style>
